import { render, staticRenderFns } from "./WallLocationsBlock.vue?vue&type=template&id=16ec2574"
import script from "./WallLocationsBlock.vue?vue&type=script&lang=js"
export * from "./WallLocationsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports